// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2Zs6g","col":"styles_col__3DW5Y"};